module.exports = __webpack_public_path__ + "img/25.01909347.png";